import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PopularVehiclesModalService {

  private selectedPopularVehicleSubject = new BehaviorSubject<any>(null);
  public selectedPopularVehicle$ = this.selectedPopularVehicleSubject.asObservable();

  constructor() { }

  setSelectedPopularVehicle(popularVehicle: any): void {
    this.selectedPopularVehicleSubject.next(popularVehicle);
  }

  getSelectedPopularVehicle(): any | null {
    return this.selectedPopularVehicleSubject.value;
  }

  clearSelectedPopularVehicle(): void {
    this.selectedPopularVehicleSubject.next(null);
  }
}

